module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_detail') === -1 && _vm.$route.path.indexOf('_edit') === -1) ? _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "商品类型"
    },
    on: {
      "change": _vm.typeSelectHandle
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "标题"
    },
    model: {
      value: (_vm.title),
      callback: function($$v) {
        _vm.title = $$v
      },
      expression: "title"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.titleSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "start-placeholder": "开始日期",
      "ange-separator": "至",
      "end-placeholder": "结束日期",
      "value-format": "yyyy/MM/dd",
      "placeholder": "选择日期范围"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.created),
      callback: function($$v) {
        _vm.created = $$v
      },
      expression: "created"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "商品分类"
    },
    on: {
      "change": _vm.search
    },
    model: {
      value: (_vm.category_id),
      callback: function($$v) {
        _vm.category_id = $$v
      },
      expression: "category_id"
    }
  }, _vm._l((_vm.category), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "size": "mini",
        "value": item.category_id
      }
    })
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$route.path.indexOf('_detail') === -1 && _vm.$route.path.indexOf('_edit') === -1) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-circle-plus-outline"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("新增商品")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-edit"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(1)
      }
    }
  }, [_vm._v("批量上架")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-edit"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(0)
      }
    }
  }, [_vm._v("批量下架")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dataList
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "label": "全选"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "goods_id",
      "label": "商品id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "标题"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "图片",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticStyle: {
            "width": "60px"
          },
          attrs: {
            "src": scope.row.goods_info[0].pics,
            "alt": ""
          }
        })]
      }
    }], null, false, 4140785626)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品名称",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n         " + _vm._s(scope.row.goods_info[0].item_title) + "\n        ")]
      }
    }], null, false, 104615022)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "description",
      "label": "描述"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "过期方式"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == 0) ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("灵活过期")]) : _c('el-tag', [_vm._v("统一过期")])]
      }
    }], null, false, 785994)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否可用",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.is_can_use == 1) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("是")]) : _c('el-tag', [_vm._v("否")])]
      }
    }], null, false, 770425446)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.row.goods_id)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.del(scope.row.goods_id)
            }
          }
        }, [_vm._v("删除")])]
      }
    }], null, false, 1500918850)
  })], 1), _vm._v(" "), (_vm.pagers.total > 0) ? _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.fetchParams.page,
      "page-sizes": [10, 20, 50, 100],
      "total": _vm.pagers.total,
      "page-size": _vm.fetchParams.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.fetchParams, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.fetchParams, "page", $event)
      }
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-55147979", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55147979"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/long/goods/index.vue
// module id = 2722
// module chunks = 0